/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { TextArea, RadioButtonGroup, RadioButton, Button } from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import PropTypes from 'prop-types';

export default class CheckListQuestionAnswer extends Component {
  render() {
    const answers = [
      { id: 'b889f9bd-4be0-41d5-8ec4-6d08bf72f49c', name: 'Yes' },
      { id: '1159220d-9045-4a55-8e97-659d55e4e4c4', name: 'No' },
      { id: 'f5a6965c-b3a7-45ef-b481-4b77e1501bac', name: 'N/A' },
    ];
    const validationAnswer = {
      answer: this.props.validator.message(
        `answer to the question  ${this.props.questionCode}`,
        this.props.answer,
        'required'
      ),
    };
    return (
      <div className="bx--row">
        <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12">
          <fieldset className="bx--fieldset">
            <legend className="bx--label checklist-custom-content ">
              {this.props.questionCode}
              {this.props.isCustom ? (
                <>
                  <Button
                    size="small"
                    renderIcon={Edit16}
                    iconDescription="Edit"
                    onClick={this.props.onUpdateCustomRequirement}
                    kind="ghost"
                    className="checklist-custom-content-detail"
                    disabled={this.props.disabled}
                    
                  />
                  <Button
                    size="small"
                    renderIcon={Delete16}
                    iconDescription="Delete"
                    onClick={this.props.onDeleteCustomRequirement}
                    kind="ghost"
                    className="checklist-custom-content-info "
                    disabled={this.props.disabled}
                  />
                </>
              ) : (
                ''
              )}
            </legend>
            <span className="bx--label">{this.props.question}</span>
          </fieldset>
        </div>
        <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 align-content-center">
          <fieldset className="bx--fieldset">
            <legend className="bx--label checklist-custom-content">Answer</legend>
            <RadioButtonGroup
              id={`rbg${this.props.id}`}
              defaultSelected={this.props.answer}
              labelPosition="right"
              legend="Group Legend"
              name={`rbg${this.props.id}`}
              // onChange={this.props.onAnswerChange}
              orientation="horizontal"
              valueSelected={this.props.answer}
              disabled={this.props.disabled}
            >
              <RadioButton
                className="some-class"
                id={`btnNO${this.props.id}`}
                onClick={() => this.props.onAnswerChange(this.props.id, answers[0])}
                labelText={answers[0].name}
                value={answers[0].id}
                disabled={this.props.disabled}
              />
              <RadioButton
                className="some-class"
                id={`btnYes${this.props.id}`}
                onClick={() => this.props.onAnswerChange(this.props.id, answers[1])}
                labelText={answers[1].name}
                value={answers[1].id}
                disabled={this.props.disabled}
              />
              <RadioButton
                className="some-class"
                id={`btnNA${this.props.id}`}
                onClick={() => this.props.onAnswerChange(this.props.id, answers[2])}
                labelText={answers[2].name}
                value={answers[2].id}
                disabled={this.props.disabled}
              />
            </RadioButtonGroup>
          </fieldset>
          {validationAnswer.answer}
        </div>
        <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12">
          <fieldset className="bx--fieldset">
            <legend className="bx--label checklist-custom-content">Notes</legend>
            <TextArea
              maxLength={5000}
              labelText=""
              className="some-class"
              cols={50}
              disabled={this.props.disabled}
              light={false}
              onChange={this.props.onNoteChange}
              placeholder=""
              rows={4}
              value={this.props.note || ''}
            />
          </fieldset>
        </div>
      </div>
    );
  }
}

CheckListQuestionAnswer.propTypes = {
  id: PropTypes.string.isRequired,
  questionCode: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string,
  note: PropTypes.string,
  isCustom: PropTypes.bool,
  onAnswerChange: PropTypes.func.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  onDeleteCustomRequirement: PropTypes.func,
  onUpdateCustomRequirement: PropTypes.func,
  disabled: PropTypes.bool
};
CheckListQuestionAnswer.defaultProps = {
  answer: null,
  note: null,
  isCustom: false,
  disabled: true,
  onDeleteCustomRequirement: () => {},
  onUpdateCustomRequirement: () => {},
};
